import React from 'react';
import cn from 'classnames';

import {getHttpIncidentLocationsCounts, getHttpIncidentTooltip} from 'features/http/lib/httpIncidentView';
import IHttpIncident from 'features/http/model/HttpIncident/IHttpIncident';
import useHttpIncidentRow from 'features/http/model/useHttpIncidentRow';
import {isTranslate} from 'shared/lib/lang';

import {t} from '@lingui/core/macro';

import IncidentStatusBadge from '../../../../../shared/ui/Status/IncidentStatusBadge';
import DateWithTodayYesterdayAccent from '../../../../../shared/ui/Date/DateWithTodayYesterdayAccent';
import Back from '../../../../../shared/ui/icons/General/Back';
import HttpIncidentModal from '../HttpIncidentModal/HttpIncidentModal';
import IncidentStatus from '../../../../../shared/ui/Status/IncidentStatus';

import HttpMonitorLocationsCounterStatus
    from '../../HttpMonitor/HttpMonitorLocationsCounterStatus/HttpMonitorLocationsCounterStatus';

import styles from './HttpIncidentRow.module.scss';

interface IHttpIncidentRowProps {
    item: IHttpIncident,
    tzString?: string | null,
    hideMonitor: boolean,
}

const HttpIncidentRow: React.FC<IHttpIncidentRowProps> = ({item, tzString, hideMonitor}) => {
    const {isModalOpen, handleClose, onTrClick, onButtonClick} = useHttpIncidentRow(item);
    const locationsCounts = getHttpIncidentLocationsCounts(item);

    return (
        <>
            <tr className={cn(styles.tr, 'clickable')} onClick={onTrClick}>
                <td>
                    <div
                        className={styles.blockIncidentStatus}
                        title={getHttpIncidentTooltip(item)}
                    >
                        <IncidentStatus
                            resolved={item.resolved}
                            incompleteFail={item.incomplete_fail}
                            incompleteSuccess={item.incomplete_success}
                        />
                        <IncidentStatusBadge
                            resolved={item.resolved}
                            className={cn(styles.status, isTranslate() && styles.statusTranslate)}
                        />
                    </div>
                </td>
                {!hideMonitor && <td>{item.monitor.name}</td>}
                <td>
                    <HttpMonitorLocationsCounterStatus
                        title={t`Результат на момент инцидента`}
                        count={locationsCounts.count}
                        totalLocationsCount={locationsCounts.total}
                        lastResult={item.locations}
                        ok={false}
                    />
                </td>
                <td><DateWithTodayYesterdayAccent datetime={item.created_at} tzString={tzString}/></td>
                <td><DateWithTodayYesterdayAccent datetime={item.resolved_at} tzString={tzString}/></td>
                <td className={styles.text_gray}>{item.duration_formatted}</td>
                <td onClick={onButtonClick}>
                    <span className={styles.icon}>
                        <Back/>
                    </span>
                </td>
            </tr>

            <HttpIncidentModal
                open={isModalOpen}
                item={item}
                handleClose={handleClose}
                tzString={tzString}
            />
        </>
    );
};

export default HttpIncidentRow;